import Link from 'next/link';
import { FC, JSX } from 'react';

import { formatUnixTimestamp } from '@/utils/date';

export const NAME = 'title-date';

type Props = {
  title: string;
  alias: string;
  date: number;
  titleTag?: string;
};

const TitleDateTemplate: FC<Props> = ({ title, alias, date, titleTag = 'h2' }) => {
  const TitleTag = titleTag as keyof JSX.IntrinsicElements;

  return (
    <div className="wp-block wp-title-date-template">
      <TitleTag>
        <Link href={alias}>{title}</Link>
      </TitleTag>
      <p>{formatUnixTimestamp(date)}</p>
    </div>
  );
};

export default TitleDateTemplate;
